import React, { useState } from 'react'
import { Button, ButtonType, TextInput } from '@resurs-internal/styx-react'
import SyntaxHighlighter from 'react-syntax-highlighter'
import { uuid } from '../utils/testUtils'
import { Card } from './Card'

import commonStyles from './styles.module.scss'

const prettyPrintData = dataString =>
  dataString && JSON.stringify(JSON.parse(dataString), null, 2)

const emptyFlow = {
  id: '$flow_id',
  object: {
    id: '$flow_id',
    tasks: [],
    currentTask: {
      taskType: 'TASK_TYPE',
      status: 'INITIALIZED',
      metadata: {},
    },
    customerType: 'NATURAL',
    countryCode: 'SE',
    previousTask: null,
    applicantType: 'MAIN_APPLICANT',
    flowUrl: '/task_url/$flow_id?mocked=$mock_id',
  },
  type: 'FLOW',
}

export const EventEditor = ({
  value: { data = '', description = '', id = uuid() } = {},
  onChange,
  onDelete,
  onCopy,
  isNew = false,
}) => {
  const [edit, setEdit] = useState(isNew)
  const [invalid, setInvalid] = useState(false)
  const [internalValue, setInternalValue] = useState(
    prettyPrintData(data || JSON.stringify(emptyFlow)),
  )
  const [props, setProps] = useState({
    description,
    data,
    id,
  })

  const onChangeDataInternal = next => {
    console.log(next)
    setInternalValue(next)
    try {
      onChange({
        data: prettyPrintData(next),
        description,
      })
      setInvalid(false)
    } catch (e) {
      setInvalid(true)
    }
  }

  const onChangeProp = (key, value) =>
    setProps(prev => ({ ...prev, [key]: value }))

  const save = () => {
    onChange({
      ...props,
      data: JSON.stringify(JSON.parse(internalValue)),
    })
    setEdit(false)
  }

  return (
    <Card header="Flow Event Mock">
      <div className={commonStyles.flexCol}>
        <TextInput
          id="description"
          label="Description"
          value={props.description}
          disabled={!edit}
          onChange={onChangeProp}
        />
        {edit ? (
          <textarea
            value={internalValue}
            onChange={e => onChangeDataInternal(e.target.value)}
            style={{ minHeight: '400px', fontSize: '12px' }}
            rows={(internalValue.match(/\n/g)?.length || 0) + 2}
          />
        ) : (
          <SyntaxHighlighter language="json" customStyle={{ fontSize: '12px' }}>
            {prettyPrintData(data)}
          </SyntaxHighlighter>
        )}
        <div
          style={{ flexDirection: 'row-reverse' }}
          className={commonStyles.flexRow}
        >
          <Button
            id="edit_event"
            type={ButtonType.Primary}
            disabled={invalid}
            onClick={() => (edit ? save() : setEdit(!edit))}
          >
            {edit ? 'Done' : 'Edit'}
          </Button>
          <Button id="duplicate_event" onClick={onCopy}>
            Duplicate
          </Button>
          <Button id="delete_event" type="secondary" onClick={onDelete}>
            Delete
          </Button>
        </div>
      </div>
    </Card>
  )
}
